<a class="d-block position-relative icon-size-m" [routerLink]="{ cxRoute: 'cart' } | cxUrl" data-analytics="cart_block">
  <sd-icon class="icon-size-l icon-size-lg-m" type="basket"></sd-icon>

  @if (quantity$ | async; as quantity) {
    <span class="text-c2-m-700 cart-badge">
      {{ quantity }}
    </span>
  }
</a>
